import React from 'react';
import Sidebar from '@components/Sidebar';
import { Page } from '@styles/globalStyles';

const Layout = ({ children }) => (
  <Page>
    <Sidebar />
    {children}
  </Page>
);

export default Layout;
